import React from 'react';

function Footer({ setView }) {
  const handleNavClick = (e, view, path) => {
    e.preventDefault();
    if (setView) {
      window.history.pushState({}, '', path);
      setView(view);
    } else {
      window.location.href = path;
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer-section">
      <div className="container">

        {/* Footer Columns */}
        <div className="footer-columns-grid">

          {/* Services Column (split into 3 sub-lists internally) */}
          <div className="footer-col services-col">
            <h3 className="footer-col-title">Services</h3>
            <div className="services-lists-wrapper">
              <ul className="footer-list">
                <li>
                  <a href="/bpo-services/" onClick={(e) => handleNavClick(e, 'bpo-services', '/bpo-services/')}>
                    BPO Services
                  </a>
                </li>
                <li>
                  <a href="/it-services/" onClick={(e) => handleNavClick(e, 'it-services', '/it-services/')}>
                    IT Services
                  </a>
                </li>
                <li>
                  <a href="/logo-design/" onClick={(e) => handleNavClick(e, 'logo-design', '/logo-design/')}>
                    Logo Design
                  </a>
                </li>
              </ul>
              <ul className="footer-list">
                <li>
                  <a href="/web-design/" onClick={(e) => handleNavClick(e, 'web-design', '/web-design/')}>
                    Web Design
                  </a>
                </li>
                <li>
                  <a href="/web-development/" onClick={(e) => handleNavClick(e, 'web-development', '/web-development/')}>
                    Web Development
                  </a>
                </li>
                <li>
                  <a href="/ecommerce-web-development/" onClick={(e) => handleNavClick(e, 'ecommerce-web-development', '/ecommerce-web-development/')}>
                    E Commerce Web Development
                  </a>
                </li>
              </ul>
              <ul className="footer-list">
                <li>
                  <a href="/digital-marketing/" onClick={(e) => handleNavClick(e, 'digital-marketing', '/digital-marketing/')}>
                    Digital Marketing
                  </a>
                </li>
                <li>
                  <a href="/seo-services/" onClick={(e) => handleNavClick(e, 'seo-services', '/seo-services/')}>
                    SEO Services
                  </a>
                </li>
                <li>
                  <a href="/social-media-marketing/" onClick={(e) => handleNavClick(e, 'social-media-marketing', '/social-media-marketing/')}>
                    Social Media Marketing
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* Quick Links Column */}
          <div className="footer-col quick-links-col">
            <h3 className="footer-col-title">Quick Links</h3>
            <ul className="footer-list">
              <li>
                <a href="/about/" onClick={(e) => handleNavClick(e, 'about', '/about/')}>
                  About Experts Communication
                </a>
              </li>
              <li>
                <a href="/team/" onClick={(e) => handleNavClick(e, 'team', '/team/')}>
                  Team
                </a>
              </li>
              <li>
                <a href="/careers/" onClick={(e) => handleNavClick(e, 'careers', '/careers/')}>
                  Careers
                </a>
              </li>
              <li>
                <a href="/contact/" onClick={(e) => handleNavClick(e, 'contact', '/contact/')}>
                  Contact Us
                </a>
              </li>
            </ul>
          </div>

          {/* Reach to Us Column */}
          <div className="footer-col reach-us-col">
            <h3 className="footer-col-title">Reach to us</h3>
            <ul className="footer-list contact-list">
              <li>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="footer-icon">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                </svg>
                <a href="tel:+923177770002">+92 (317) 777 0002</a>
              </li>
              <li>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="footer-icon">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                  <polyline points="22,6 12,13 2,6" />
                </svg>
                <a href="mailto:info@expertscommunication.net">info@expertscommunication.net</a>
              </li>
              <li>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="footer-icon">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                  <circle cx="12" cy="10" r="3" />
                </svg>
                <span>KDA Commercial Building, Office # 3, First Floor, North Nazimabad, Block A, Karachi</span>
              </li>
            </ul>
          </div>

        </div>

        {/* Footer Locations & Trust Block */}
        <div className="footer-locations-row">
          <div className="locations-wrapper">
            <h4 className="locations-title">Locations</h4>
            <div className="locations-list">
              <span>PK</span>
              <span className="loc-divider">|</span>
              <span>UAE</span>
              <span className="loc-divider">|</span>
              <span>US</span>
              <span className="loc-divider">|</span>
              <span>CA</span>
              <span className="loc-divider">|</span>
              <span>AU</span>
            </div>
          </div>

          <div className="footer-trust-divider"></div>

          <div className="footer-trust-block">
            <div className="trust-left">
              <a href="tel:+923177770002" className="trust-link">+92 (317) 777 0002</a>
              <span className="trust-divider">|</span>
              <a href="mailto:info@expertscommunication.net" className="trust-link">info@expertscommunication.net</a>

              <div className="dmca-logo-box">
                <img
                  src="/assets/images/dmca_premi_badge_4-1.png"
                  alt="DMCA Protected"
                  className="dmca-img"
                />
              </div>
            </div>

            <div className="trust-right">
              {/* Social Icons */}
              <div className="social-links">
                <a href="https://www.facebook.com/expertscomm" target="_blank" rel="noopener noreferrer" className="social-circle" aria-label="Facebook">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M22.675 0h-21.35c-.732 0-1.325.593-1.325 1.325v21.351c0 .731.593 1.324 1.325 1.324h11.495v-9.294h-3.128v-3.622h3.128v-2.671c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.795.143v3.24l-1.918.001c-1.504 0-1.795.715-1.795 1.763v2.313h3.587l-.467 3.622h-3.12v9.293h6.116c.73 0 1.323-.593 1.323-1.325v-21.35c0-.732-.593-1.325-1.325-1.325z" />
                  </svg>
                </a>
                <a href="https://www.instagram.com/expertscommunication/" target="_blank" rel="noopener noreferrer" className="social-circle" aria-label="Instagram">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
                  </svg>
                </a>
                <a href="https://x.com/ExpertsCommuni2" target="_blank" rel="noopener noreferrer" className="social-circle" aria-label="X">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                  </svg>
                </a>
                <a href="https://www.linkedin.com/company/experts-communication/" target="_blank" rel="noopener noreferrer" className="social-circle" aria-label="LinkedIn">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Sub Footer Row */}
        <div className="sub-footer-row">
          <span className="copyright-text">© 2026 Experts Communication. All rights reserved.</span>
          <div className="sub-footer-links">
            <a href="/terms-and-conditions/" onClick={(e) => handleNavClick(e, 'terms-and-conditions', '/terms-and-conditions/')}>Terms and Conditions</a>
            <span className="sub-link-divider">|</span>
            <a href="/privacy-policy/" onClick={(e) => handleNavClick(e, 'privacy-policy', '/privacy-policy/')}>Privacy Policy</a>
          </div>
        </div>

      </div>
    </footer>
  );
}

export default Footer;
